import styled from 'styled-components';

export default styled.div`
  max-width: 1200px;
  width: 100%;
  @media screen and (min-height: 667px) and (hover: none) {
    padding-bottom: 90pt;
  }
`;
